import { Ease24, Tween24 } from 'tween24'
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import common from './modules/common'
import './index.scss'

const elementIntersecting = document.querySelectorAll('.lbox')
const intersectOptions = {
  rootMargin: "-40% 0px",
  threshold: 0,
}
const observer = new IntersectionObserver(showContent, intersectOptions)

window.addEventListener('load', () => {
  common()
  
  elementIntersecting.forEach(box => {
    observer.observe(box)
  })
})

function showContent (entries) {
  entries.forEach( entry => {
    if(entry.isIntersecting) {
      if(!entry.target.classList.contains('shown')) {
        entry.target.classList.add('shown')
        Tween24.serial(
          Tween24.prop(entry.target).y(100),
          Tween24.tween(entry.target, .4, Ease24._2_QuadOut).opacity(1).y(0)
        ).play()  
      }
    }
  })
}